/* global toastr */

import { BaseListView } from '../smart_bps/bps/list_view'
import React from 'react'
import {AuthorizedDropDownMeny, UnauthorizedDropDownMenu} from "./NavDropdownMenu";
import { SigurModalSearch } from "./SigurModalSearch";

export class SigurListView extends BaseListView {

  constructor(props) {
    super(props)
    this.renderTopPanelRightItems = this.renderTopPanelRightItems.bind(this)
    this.getPresetBtn = this.getPresetBtn.bind(this)
    this.getPresetCounter = this.getPresetCounter.bind(this)
    this.savePreset = this.savePreset.bind(this)
  }

  renderTopPanelRightItems() {
    if (this.authorized) {
      return (
        <AuthorizedDropDownMeny
          userTitle={this.user_title}
          onLogout={this.logout}
        />
      )
    }
    return <UnauthorizedDropDownMenu/>
  }

  getPresetBtn() {
    let preset_items = []
    const { search_presets, search_preset } = this.props
    const styleActive = { borderBottom: "2px solid rgb(255, 90, 0)", paddingBottom: "7px" }

    search_presets && search_presets.forEach(item => {
      const preset_name = item[0]
      const preset_title = item[1]
      const preset_count = this.getPresetCounter(preset_name)
      preset_items.push(<li key={preset_name}>
        <a onClick={() => this.savePreset(preset_name)} className="dropdown-item">
          {preset_name === search_preset && (<i className="ti ti-checks me-1"></i>)}
          {preset_title} {preset_count !== undefined ? <span className="text-muted">- {preset_count}</span> : ""}
        </a>
      </li>)
    })

    let presets = null;
    if (preset_items.length > 0) {
      const preset_style = search_preset ? styleActive : undefined

      presets = <span className="dropdown me-2" key="presets">
        <a className="dropdown-toggle hide-arrow" style={preset_style} data-bs-toggle="dropdown" onClick={() => { this.setState({ hasPresetOpen: true }) }}>
          <i className="ti ti-filter me-2"></i>
          <span className="d-none d-md-inline-block">Отбор</span>
        </a>
        <ul className="dropdown-menu mt-2">
          <li key="reset">
            <a onClick={() => this.savePreset('')} className="dropdown-item">
              <i className="ti ti-trash-x me-1"></i>
              Сброс
            </a>
          </li>
          {preset_items}
        </ul>
      </span>
    }

    return presets
  }

  renderTopPanelLeftItems() {
    const items = super.renderTopPanelLeftItems()

    return items.map(item => {
      if (!item) return item
      const child = item.props.children

      if (item.key === 'search') {
        const currentStyle = child.props.style

        if (currentStyle) {
          const orangeStyle = {
            ...currentStyle,
            borderBottom: "2px solid rgb(255, 90, 0)"
          }

          const modifiedChild = React.cloneElement(child, { style: orangeStyle })

          return React.cloneElement(item, {}, modifiedChild)
        }
      }

      return item
    })
  }

  renderModals() {
    if (this.props.search_form) {
      return [<SigurModalSearch
        project_name={this.project_name}
        schema={this.props.search_form}
        data={this.props.search_data}
        onSearch={this.onSearch}
        choices={this.props.choices}
      />]
    }

    return []
  }

}
